export function filterPrice(value) {
  if (value == 1) {
    return '/万字'
  }
  if (value == 2) {
    return '/篇'
  }
  if (value == 0) {
    return '/千字'
  }
  return ''
}

export function registerGlobalFilters(app) {
  app.config.globalProperties.$filters = {
    filterPrice
  }
}
